export default __webpack_public_path__ + "static/media/melanie_tan.f153c9fa.jpg";